// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180334/js/" + chunkId + "." + {"44":"2a92b84b","225":"b68fd6ef","481":"7f00fcb3","486":"489a8465","770":"c23ddc07"}[chunkId] + ".0.24918755016732252.chunk.js";
};